function cov_v9hvqvka7() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockLeft.tsx";
  var hash = "f3193bc7a30facdf6d5d15a9882adf8849418d3d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/UnlockLeft.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f3193bc7a30facdf6d5d15a9882adf8849418d3d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_v9hvqvka7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_v9hvqvka7();
var Icon = (cov_v9hvqvka7().s[0]++, {
  name: 'unlock-left',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 12.5V19.5H18.5V12.5H5.5ZM5 10C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10H5Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 7C6.75 4.10051 9.1005 1.75 12 1.75C14.8995 1.75 17.25 4.10051 17.25 7V12H14.75V7C14.75 5.48122 13.5188 4.25 12 4.25C10.4812 4.25 9.25 5.48122 9.25 7V7.5H6.75V7Z\" fill=\"currentColor\"/>"
});
export default Icon;